  let design = 750,//设计稿的宽度
    base = 40,//基准值
    minWidth = 320,
    maxWidth = 1600,
    timer = null,
    refreshWindow = () => {
      let wWidth = document.documentElement.clientWidth
      wWidth < minWidth && (wWidth = minWidth)
      wWidth > maxWidth && (wWidth = maxWidth)
      let currentFontSize = wWidth * base / design
      document.documentElement.style.fontSize = currentFontSize + 'px'
    }
  refreshWindow()
  window.addEventListener('resize', () => {
    clearTimeout(timer)
    timer = setTimeout(refreshWindow, 10)
  }, false)



// WEBPACK FOOTER //
// ./src/assets/js/rem.js